"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconManganese = function IconManganese(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M10 8h28a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2m-4 2a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4zm8 19.4L15.152 19h1.776l2.944 6.976L22.848 19h1.712l1.152 10.4h-1.568l-.88-7.904-2.688 6.336H19.12l-2.672-6.352-.88 7.92zm13.769 0v-7.456h1.52v1.024c.384-.688 1.232-1.152 2.208-1.152 1.552 0 2.784 1.168 2.784 3.072V29.4h-1.52v-4.224c0-1.232-.624-1.952-1.712-1.952-1.104 0-1.76.752-1.76 1.984V29.4z",
    clipRule: "evenodd"
  })));
};

export { IconManganese, IconManganese as default };
